import _defineProperty from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import pdf from 'pdfast';
import { group } from 'd3-array';
export function defined(d) {
  return d !== undefined && d !== null && !Number.isNaN(d);
}
/**
 * Kernel Density Estimation base on [pdfast](https://www.npmjs.com/package/pdfast),
 * generating probability density function (pdf) using triangular kernel,
 * optimized to run in O(N + K).
 */
export var KDE = function KDE(options) {
  var field = options.field,
    groupBy = options.groupBy,
    _options$as = options.as,
    as = _options$as === void 0 ? ['y', 'size'] : _options$as,
    min = options.min,
    max = options.max,
    _options$size = options.size,
    size = _options$size === void 0 ? 10 : _options$size,
    width = options.width;
  var _as = _slicedToArray(as, 2),
    yField = _as[0],
    sizeField = _as[1];
  return function (data) {
    var gs = Array.from(group(data, function (d) {
      return groupBy.map(function (gb) {
        return d[gb];
      }).join('-');
    }).values());
    return gs.map(function (g) {
      var pdfResult = pdf.create(g.map(function (i) {
        return i[field];
      }), {
        min: min,
        max: max,
        size: size,
        width: width
      });
      var _y = pdfResult.map(function (result) {
        return result.x;
      });
      var _size = pdfResult.map(function (result) {
        return result.y;
      });
      return Object.assign(Object.assign({}, g[0]), _defineProperty(_defineProperty({}, yField, _y), sizeField, _size));
    });
  };
};
KDE.props = {};